(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('whenBodyScrolled', function($window) {
    return {
      restrict: 'A',
      scope: false,
      link: function(scope, elem, attrs) {
        var bound_func = function() {
          if (scope.notifyWhenScrolled) {
            scope.notifyWhenScrolled(elem);
          }
        };
        angular.element($window).on('scroll', bound_func);
        scope.$on('$destroy', function() {
          angular.element($window).off('scroll', bound_func);
        });
      }
    };
  });
})(window, window.angular);
